import React, { Component, Fragment } from "react";
import Breadcrumbs from "../../shared/Breadcrumbs";
import { SubscriptionCategoryRoute } from "../../routing/IndividualRoutes";

export class SubscriptionCategoryPage extends Component {
  render() {
    return (
      <Fragment>
        <Breadcrumbs />
        <SubscriptionCategoryRoute />
      </Fragment>
    );
  }
}
